import { render } from "./SetLocale.vue?vue&type=template&id=3613220a&scoped=true"
import script from "./SetLocale.vue?vue&type=script&lang=ts"
export * from "./SetLocale.vue?vue&type=script&lang=ts"

import "./SetLocale.vue?vue&type=style&index=0&id=3613220a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3613220a"

export default script